module.exports = __webpack_public_path__ + "static/media/50percentProfilePic.8910fbb2.jpg";